import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { EmploymentExpensesModel } from '../../cmg-1003/models';
import { iStoreActions } from '../core/store-actions.interface';

function createInitialState(): EmploymentExpensesModel {
  return <EmploymentExpensesModel>{};
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'cmg-1003-employment-expenses-store' })
export class Cmg1003EmploymentExpensesStore extends Store<EmploymentExpensesModel> implements iStoreActions<EmploymentExpensesModel> {
  private _initValue: EmploymentExpensesModel = null;

  constructor() {
    super(createInitialState());
  }

  preInitialize(model: EmploymentExpensesModel) {
    this.update(model);
    this._initValue = JSON.parse(JSON.stringify(this.getValue()));
  }

  get initialValue() {
    return this._initValue;
  }
}
